import { Box, Divider, ListItemButton, Paper, Skeleton, Stack } from '@mui/material'

interface Props {
  index: number
}

const thumbnailSx = {
  width: 36,
  height: 36,
  border: '2px solid #fff',
  flexShrink: 0,
} as const

function ThumbnailSkeleton() {
  return <Skeleton variant="circular" sx={thumbnailSx} />
}

export default function OrderRowSkeleton(props: Props) {
  return <>
    <Paper
      elevation={0}
      sx={{
        display: {
          xs: 'block',
          lg: 'none',
        }
      }}
    >
      <Stack divider={<Divider />}>
        <Stack sx={{ p: 2 }} spacing={1}>
          <div>
            <Stack direction="row" spacing={1} alignItems="center">
              <Skeleton variant="rounded" width={92} height={16} />
              <Skeleton variant="rounded" width={78} height={23} />
            </Stack>
            <Skeleton variant="text" width={190} height={22.5} />
          </div>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Skeleton variant="rounded" width={82} height={32} />
              <Stack direction="row" spacing={-1}>
                <ThumbnailSkeleton />
                <ThumbnailSkeleton />
                <ThumbnailSkeleton />
              </Stack>
            </Stack>
            <Skeleton variant="text" width={76} height={24} />
          </Stack>
        </Stack>
        <Stack
          direction="row"
          sx={{ p: 2 }}
          alignItems="center"
          justifyContent="space-between"
        >
          <div>
            <Skeleton variant="text" width={58} height={24} />
            <Skeleton variant="text" width={140} height={24} />
          </div>
          <Skeleton variant="rounded" width={112} height={36} />
        </Stack>
      </Stack>
    </Paper>

    <Box
      component="div"
      sx={{
        display: {
          xs: 'none',
          lg: 'block',
        },
      }}
    >
      {props.index > 0 ? <Divider /> : null}
      <ListItemButton
        component="div"
        disableRipple
        sx={{
          width: '100%',
          padding: 0,
          textAlign: 'left',
          display: 'block',
          py: 2,
          px: 2,
          cursor: 'default',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
      >
        <Stack
          direction="row"
          spacing={4}
          sx={{ alignItems: 'center' }}
        >
          <Box component="div" sx={{ width: '100px', flexShrink: 0 }}>
            <Skeleton variant="text" width={82} height={24} />
          </Box>
          <Box component="div" sx={{ width: '170px', flexShrink: 0 }}>
            <Skeleton variant="text" width={146} height={24} />
          </Box>
          <Box component="div" sx={{ flexGrow: 1, flexShrink: 1 }}>
            <Skeleton variant="text" width="45%" height={24} />
          </Box>
          <Box component="div" sx={{ width: '130px', flexShrink: 0 }}>
            <Skeleton variant="text" width={74} height={24} />
          </Box>
          <Box component="div" sx={{ width: '150px', flexShrink: 0 }}>
            <Skeleton variant="rounded" width={96} height={24} />
          </Box>
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          <Skeleton variant="rounded" width={82} height={32} />
          <Stack direction="row" spacing={-1}>
            <ThumbnailSkeleton />
            <ThumbnailSkeleton />
            <ThumbnailSkeleton />
            <ThumbnailSkeleton />
            <ThumbnailSkeleton />
          </Stack>
        </Stack>
      </ListItemButton>
    </Box>
  </>
}
